import { Resource } from "@examspark/types";

import * as fragments from "../fragments";

import { createResource, deleteResource, listResources } from "./resource";

export const deleteFile = async (item: Resource) => {
  if (!item.workspaceId) throw new Error("Missing workspaceId.");
  return deleteResource(item);
};

export const createFile = async (
  item: Omit<Resource, "schemaVersion" | "sk">,
) => {
  if (!item.workspaceId) throw new Error("Missing workspaceId.");

  return createResource({
    label: "CreateFile",
    variables: {
      ...item,
      sk: "file#" + new Date().toISOString(),
    },
  });
};

export const listFiles = async (id: string) => {
  return await listResources({
    label: "ListFiles",
    fields: `
    ${fragments.resource.items(`
      ${fragments.resource.id}
      ${fragments.resource.basic}
      ${fragments.resource.file}
    `)}
  `,
    variables: {
      id,
      sk: {
        beginsWith: "file#",
      },
    },
  });
};
